import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  Typography
} from '@material-ui/core';

const styles = theme => ({
  root: {
    background: 'url(/static/images/jumbotron.jpg) center no-repeat',
    backgroundAttachment: 'fixed',
    backgroundSize: 'cover',
    height: '450px',
  },
  name1: {
    fontWeight: 900,
  },
  name2: {
    fontWeight: 900,
  },
});

class Jumbotron extends Component {

  render() {
    const { classes } = this.props;
    return (
      <Grid
        container
        alignItems="center"
        direction="row"
        justify="center"
        className={classes.root}
      >
        <Grid>
          <Typography
            variant="display3"
            align="center"
            className={classes.name1}
          >
            GRENARCH
          </Typography>
          <Typography
            variant="display2"
            align="center"
            className={classes.name2}
          >
            Technologies
          </Typography>
        </Grid>
      </Grid>
    );
  }
};

Jumbotron.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Jumbotron);



// WEBPACK FOOTER //
// ./src/components/index/Jumbotron.js